module.exports = __webpack_public_path__ + "assets/img/doctors_online.d2f22314.png";